import { useState } from 'react';

import { generateInvoicePdfApi, generateWithdrawalPdfApi } from '@api/billing-publisher.api';
import { createBlobFromResponse } from '@helpers/fileHelpers';

type DownloadResponse = { title: string };

const triggerBlobDownload = (
  res: DownloadResponse & Parameters<typeof createBlobFromResponse>[0]
) => {
  const blob = createBlobFromResponse(res);
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = res.title;
  link.click();
  link.remove();
};

type UseReceiptDownload = {
  activeId: number | null;
  download: (id: number) => void;
};

export const useInvoicePdfDownload = (workspaceId: number): UseReceiptDownload => {
  const [activeId, setActiveId] = useState<number | null>(null);
  const download = (id: number) => {
    setActiveId(id);
    generateInvoicePdfApi(id, workspaceId)
      .then(triggerBlobDownload)
      .catch((err) => console.error(err))
      .finally(() => setActiveId(null));
  };
  return { activeId, download };
};

export const useWithdrawalPdfDownload = (workspaceId: number): UseReceiptDownload => {
  const [activeId, setActiveId] = useState<number | null>(null);
  const download = (id: number) => {
    setActiveId(id);
    generateWithdrawalPdfApi(id, workspaceId)
      .then(triggerBlobDownload)
      .catch((err) => console.error(err))
      .finally(() => setActiveId(null));
  };
  return { activeId, download };
};
